<template>
  <router-view/>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'App',
  computed: {
    ...mapState('Sites', [
      'selected'
    ]),
    selectedSiteName () {
      return this.selected ? this.selected.name : ''
    }
  },
  watch: {
    selected () {
      this.setTabTitle()
    }
  },
  methods: {
    setTabTitle () {
      document.title = this.selectedSiteName
    }
  }
}
</script>
